import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import React, { Component } from "react";
import { Spin, Form, Input, Select, Checkbox, Modal, Collapse } from "antd";
import BlueButton from "../common/bluebutton";
import BackButton from "../common/backbutton";
import { Title } from "../title";
import { SubTitle } from "../subtitle";
import ReCAPTCHA from "react-google-recaptcha";
import { withTranslation } from "react-i18next";
import MapPlacesInput from "../common/mapPlacesInput";
import mapTarget from "../../img/map_target.png";
import './index.scss';
const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;
const win = window;
var MySelf;
class MobilyForm extends Component {
    constructor(props) {
        super(props);
        this.toggleMapModalBox = (itemName) => {
            itemName ? this.setState({
                mapModalVisible: !this.state.mapModalVisible,
                currentAdressItemName: itemName
            }) : this.setState({
                mapModalVisible: !this.state.mapModalVisible,
            });
        };
        this.handleAddressChange = (newAddress, fieldName) => {
            if (!!newAddress) {
                this.formRef.current.setFieldsValue({
                    [fieldName]: newAddress,
                });
            }
            this.toggleMapModalBox();
        };
        this.onBoxSelect = (itemName, item) => {
            try {
                this.formRef.current.setFieldsValue({
                    [itemName]: item,
                });
                this.setState({
                    myForm: this.formRef.current,
                });
            }
            catch (e) {
                console.log(e);
            }
        };
        MySelf = this;
        this.formRef = React.createRef();
        this.state = {
            myForm: {},
            errorFieldKeys: [],
            errorFields: [],
            mapModalVisible: false,
            currentAdressItemName: "",
        };
    }
    componentDidMount() {
        MySelf.setState({
            myForm: this.formRef.current,
        });
        if (this.props.formRef) {
            this.props.formRef.current = this.formRef;
        }
    }
    renderDataTableType(col) {
        const { t, formModal } = this.props;
        switch (col.type) {
            case "table":
                return col.data.length > 0 ? (_jsxs("div", Object.assign({ id: "no-more-tables" }, { children: [_jsxs("table", Object.assign({ className: "table-responsive table-borderless table" }, { children: [_jsx("thead", Object.assign({ className: "tableHead" }, { children: _jsxs("tr", { children: [col.firstCol === "checkbox" ? (_jsx("th", { className: "tableHeader", scope: "col" }, void 0)) : (""), Object.keys(col.data[0]).map((header, j) => {
                                                if (!col.dispalyCols || col.dispalyCols.includes(header)) {
                                                    return (_jsx("th", Object.assign({ className: "tableHeader", scope: "col" }, { children: t(header) }), j));
                                                }
                                            })] }, void 0) }), void 0), _jsx("tbody", { children: col.data.map((row, i) => {
                                        var isDisabled = false;
                                        if (col.disableOn && col.disableOn.values) {
                                            isDisabled = col.disableOn.values.includes(row[col.disableOn.name]);
                                        }
                                        return (_jsxs("tr", Object.assign({ className: "" }, { children: [col.firstCol === "checkbox" ? (_jsx("td", Object.assign({ className: "tableColumn pt-4 pb-2" }, { children: _jsx(Form.Item, Object.assign({ name: row[col.idCol] }, { children: _jsx(Checkbox.Group, { disabled: isDisabled, options: [{ label: "", value: row[col.idCol] }], value: row[col.idCol] }, void 0) }), void 0) }), void 0)) : (""), Object.keys(row).map((innerCol, j) => {
                                                    if (!col.dispalyCols ||
                                                        col.dispalyCols.includes(innerCol)) {
                                                        var postFix;
                                                        if (col.postfixValues) {
                                                            postFix = col.postfixValues.find((item) => item.name === innerCol);
                                                        }
                                                        return (_jsx("td", Object.assign({ "data-title": t(innerCol), className: "tableColumn pt-4 pb-2" }, { children: _jsx("div", { children: Object.keys(col.data[0]).filter((header, j) => {
                                                                    let fun = row[innerCol];
                                                                    if (header === "" && typeof fun === 'function') {
                                                                        return true;
                                                                    }
                                                                }).length > 0 ? row[innerCol](this.props.formModal.collapsedState) : row[innerCol] }, void 0) }), `col${i}${j}`));
                                                    }
                                                })] }), `row${i}`));
                                    }) }, void 0)] }), void 0), _jsx("div", Object.assign({ style: {
                                background: "#F2F4F8",
                                width: "100%",
                                minHeight: 100,
                                visibility: this.props.formModal.collapsedState ? 'visible' : "hidden",
                                display: this.props.formModal.collapsedState ? 'block' : "none"
                            }, className: `tableRow ${formModal.tableClassName}` }, { children: _jsx("p", Object.assign({ className: "collapse-text" }, { children: this.props.formModal.collapseText }), void 0) }), void 0)] }), void 0)) : (_jsx("div", Object.assign({ className: col.noDataMsgClass }, { children: col.noDataMsg }), void 0));
            default:
                return "";
        }
    }
    inputFocus(name) {
        $("div[class*=" + name + "]>:first-child").addClass("labelFocus", {
            duration: 500,
        });
    }
    inputBlur(name) {
        var inputVal = $("input[id=" + name + "]").val();
        if (!inputVal || inputVal.length === 0)
            $("div[class*=" + name + "]>:first-child").removeClass("labelFocus", {
                duration: 500,
            });
    }
    renderFieldType(col) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { myForm } = this.state;
        switch (col.type) {
            case "label":
                return col.visible ? _jsx("div", { children: col.text }, void 0) : "";
            case "text":
                return (_jsx(Input, { placeholder: col.placeholder, readOnly: col.readOnly, maxLength: col.maxLength, onFocus: (e) => this.inputFocus(col.itemName), onBlur: (e) => this.inputBlur(col.itemName) }, void 0));
            case "map":
                return _jsxs(_Fragment, { children: [_jsx(Input, { readOnly: col.readOnly, placeholder: !((_c = (_b = (_a = this.formRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getFieldValue(col.itemName)) === null || _c === void 0 ? void 0 : _c.address) ? col.placeholder : "", value: (_f = (_e = (_d = this.formRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.getFieldValue(col.itemName)) === null || _f === void 0 ? void 0 : _f.address }, void 0), _jsx("div", Object.assign({ className: "search-icon" }, { children: _jsx("img", { src: mapTarget, className: "icon-img", onClick: () => this.toggleMapModalBox(col.itemName) }, void 0) }), void 0)] }, void 0);
            case "dropdown":
                const options = col.data.map((d) => (_jsx(Option, { children: d[col.dataText] }, d[col.dataKey])));
                return _jsx(Select, Object.assign({ placeholder: col.defaultText }, { children: options }), void 0);
            case 'box-select':
                return _jsx("div", Object.assign({ className: 'box-select-container' }, { children: (_g = col.data) === null || _g === void 0 ? void 0 : _g.map((item, i) => {
                        var _a, _b, _c, _d;
                        return _jsx("div", Object.assign({ onClick: () => {
                                this.onBoxSelect(col.itemName, item);
                                col.onClick(item);
                            }, className: `${'box-item d-flex align-items-center '
                                + (!!(((_b = (_a = this.formRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getFieldValue(col.itemName)) && ((_d = (_c = this.formRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.getFieldValue(col.itemName)[col.dataKey]) == item[col.dataKey])
                                    ? '   box-selected' : '')}` }, { children: _jsx("p", Object.assign({ className: 'box-text' }, { children: item[col.dataKey] }), void 0) }), i);
                    }) }), void 0);
            case "chiled":
                return col.chiled;
            case "textarea":
                return (_jsx(TextArea, { rows: col.rows, showCount: {
                        formatter: (textObj) => `${textObj.count} ${col.counterText} ${textObj.maxLength}`,
                    }, placeholder: col.placeholder, maxLength: col.maxLength }, void 0));
            case "button":
                return (_jsx("div", Object.assign({ className: col.buttonColClass }, { children: _jsx(BlueButton, { buttonClass: `blueButton ${col.buttonClass}`, disabled: col.disabled, text: col.buttonText, form: this.formRef.current, onClick: col.buttonAction }, void 0) }), void 0));
            default:
                return "";
        }
    }
    validateForm(values, errorFields, outOfDate) {
        var myForm = MySelf.formRef.current;
        myForm
            .validateFields()
            .then((values) => {
            MySelf.setState({
                errorFields: [],
            });
        })
            .catch((errorInfo) => {
            MySelf.setState({
                errorFields: errorInfo.errorFields,
            });
        });
    }
    validatefield(e) {
        var myForm = MySelf.formRef.current;
        var errorFieldKeys = MySelf.state.errorFieldKeys;
        if (myForm.getFieldError(e.target.id)) {
            if (!errorFieldKeys.find((item) => item === e.target.id) &&
                e.target.id.length > 0) {
                errorFieldKeys.push(e.target.id);
            }
        }
        else {
            errorFieldKeys = errorFieldKeys.filter(function (obj) {
                return obj.id !== e.target.id;
            });
        }
        myForm
            .validateFields(errorFieldKeys, { suppressWarning: true })
            .then((values) => {
            MySelf.setState({
                errorFields: [],
            });
        })
            .catch((errorInfo) => {
            MySelf.setState({
                errorFields: errorInfo.errorFields,
            });
        });
    }
    // handleSubmit = () => {
    //     var myForm = this.formRef.current;
    //     myForm.validateFields()
    //         .then(values => {
    //             if (!values.errorFields || values.errorFields.length === 0) {
    //                 this.props.formModal.buttonAction(this.formRef.current);
    //             }
    //         })
    //         .catch(errorInfo => {
    //             console.log(errorInfo);
    //         });
    // }
    render() {
        const { t, formModal } = this.props;
        const { currentAdressItemName } = this.state;
        return (_jsxs("div", Object.assign({ className: this.props.formModal.formClass }, { children: [this.props.formModal.showBackButton ?
                    _jsx("div", { children: _jsx(BackButton, { onClick: this.props.formModal.backButtonAction }, void 0) }, void 0) : '', _jsxs(Spin, Object.assign({ size: "large", spinning: this.props.loading }, { children: [this.props.formModal.title ? (_jsx(Title, { text: this.props.formModal.title, className: this.props.formModal.titleClass }, void 0)) : (""), this.props.formModal.subTitle ? (_jsx(SubTitle, { text: this.props.formModal.subTitle, className: this.props.formModal.subTitleClass }, void 0)) : (""), _jsxs(Form, Object.assign({ ref: this.formRef, layout: "vertical", className: `FormItem sansFont ${formModal.formClassName !== undefined ? formModal.formClassName : ''}`, onBlur: this.validatefield, requiredMark: false, onFinishFailed: this.validateForm, onFieldsChange: this.props.formModal.changeFields }, { children: [this.props.formModal.rows.map((row, i) => {
                                    return (_jsx("div", Object.assign({ className: `${row.rowClass}` }, { children: row.cols.map((col, j) => {
                                            return (_jsx("div", Object.assign({ className: `${col.colClass}` + ' p-0' }, { children: col.firstCol === "checkbox" || col.table ? (this.renderDataTableType(col)) : (_jsxs(Form.Item, Object.assign({ className: col.itemName, label: col.label }, { children: [_jsx(Form.Item, Object.assign({ className: `${col.colItemClass}`, name: col.itemName, rules: col.colItemRules }, { children: this.renderFieldType(col) }), void 0), col.tip ? (_jsx("div", Object.assign({ className: `${this.state.errorFields.find((item) => item.name[0] === col.itemName)
                                                                ? col.tipClass
                                                                : col.tipClass} d-flex` }, { children: _jsx("label", Object.assign({ className: "inputTip" }, { children: col.tip }), void 0) }), void 0)) : ("")] }), void 0)) }), `col${j}`));
                                        }) }), `row${i}`));
                                }), this.props.formModal.captcha ? (_jsx(ReCAPTCHA, { size: formModal.size, sitekey: this.props.formModal.captchaKey, badge: formModal.badgePosition }, void 0)) : ("")] }), void 0)] }), void 0), _jsx(Modal, Object.assign({ centered: true, maskClosable: true, keyboard: true, closable: false, visible: this.state.mapModalVisible, width: 1000, footer: null }, { children: _jsx(MapPlacesInput, { closeText: this.props.formModal.closeText, typeAddress: this.props.formModal.typeAddress, googleMapKey: win["storeGoogleMapKey"], onOk: (e) => this.handleAddressChange(e, currentAdressItemName), confirm_location: t('confirm_location'), handleClose: this.toggleMapModalBox }, this.props.formModal.mapKey) }), void 0)] }), void 0));
    }
}
export default withTranslation()(MobilyForm);
